import Vue, { CreateElement } from 'vue';
import { Component } from 'nuxt-property-decorator';

@Component({
  mounted() {
    if (this.$dataBucket.isPreview) {
      const el = document.createElement('div');
      el.className = 'h-preview-panel';
      el.innerHTML = `
        <div class="h-preview-panel__label">PREVIEW</div>
      `;
      document.body.appendChild(el);
    }
  },
  beforeMount() {
    if (this.$dataBucket.isPreview) {
      const el = document.querySelector('.h-preview-panel');
      el && el.remove();
    }
  },
})
export default class MyView extends Vue {
  protected render(h: CreateElement) {
    return h('nuxt-child');
  }
}
